export const DOCS_META = {
  badge: 'ANGULAR 21 · MATERIAL REFINED',
  angularVersion: '21.x',
  packageVersion: '21.2.4',
  packageRange: '21.2.4',
  docsPath: 'angular-21'
};
